import { deleteApi } from '../api/storeFront';
export default async (orderId, logger) => {
    return deleteApi(`/cart/${orderId}`, logger);
};
